import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsCallingSettings } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class TeamsCallHandlingAndForwardingResource {
  private $http = inject(HttpClient);

  getTeamsCallingHandlingForwarding(tenantId: string, upn: string): Observable<MicrosoftTeamsCallingSettings> {
    return this.$http.get<MicrosoftTeamsCallingSettings>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/teams-calling-handling-and-forwarding-settings/${upn}`,
    );
  }

  putTeamsCallingHandlingForwarding(
    tenantId: string,
    msTeamsCallingSettings: MicrosoftTeamsCallingSettings,
  ): Observable<void> {
    return this.$http.put<void>(
      `/services/microsoft/teams-user-management/tenants/${tenantId}/teams-calling-handling-and-forwarding-settings/${msTeamsCallingSettings.userPrincipalName}`,
      msTeamsCallingSettings,
    );
  }
}
